export function Divider({ children = <>&nbsp;</> }) {
  return <div className="flex-center f1 gray mv3 bg-accent w-100">{children}</div>
}

// // export const MAX_VIEW_PAGE_MT = 'mt3 mt4-l'
// export function MaxViewPage({
//   alignClass = 'mb8 mt4 mt5-l',
//   className = '',
//   children
// }) {
//   return (
//     <div className={`vp3-l relative mh3 mh0-l ${alignClass} ${className}`}>
//       {children}
//     </div>
//   )
// }
export const MAX_VIEW_PAGE_MV = 'mt3 mt4-l mb6'
export const MAX_VIEW_PAGE_MH = 'mh3 mh0-l vp3-l'
export function MaxViewPage({
  className = 'relative',
  mv = MAX_VIEW_PAGE_MV,
  mh = MAX_VIEW_PAGE_MH,
  children
}) {
  return <div className={`${mv} ${mh} ${className}`}>{children}</div>
}

export function Heading({ className = 'mv4', color = 'accent', children }) {
  return <h1 className={`f5 ${color} fw6 ${className}`}>{children}</h1>
}

export function Pill({ children, className = 'ba ph2', style }) {
  return (
    <span className={`br-pill ${className}`} style={style}>
      {children}
    </span>
  )
}
